import React from 'react';
import './AdminSidebar.css';

/**
 * @param {{
 *   children?: React.ReactNode,
 *   className?: string
 * }} props
 */
function AdminSidebar({ children, className = '' }) {
  return (
    <aside className={`au-sidebar au-scope${className ? ` ${className}` : ''}`}>
      {children}
    </aside>
  );
}

export default AdminSidebar;
